module.exports = "<div class=\"c-icon-tabs\">\n    <p class=\"c-icon-tabs__title\">{{tagLine}}:</p>\n    <ul class=\"c-icon-tabs__list\">\n        <li class=\"c-icon-tabs__el\" v-for=\"(tab, index) in tabs\">\n            <a @click=\"selectTab(index)\" @keyup.enter=\"selectTab(index)\" class=\"c-icon-tabs__link\" :class=\"{ 'is-selected': selected == index }\"><span class=\"c-icon-tabs__icon\" v-html=\"tab.icon\"></span><span>{{tab.name}}</span></a>\n        </li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/icon-tabs/icon-tabs.vhtml
// module id = 306
// module chunks = 0